export default __webpack_public_path__ + "static/media/Punjabi-Kada.3eba0360.jpg";